import {Nav} from "react-bootstrap";
import {useEffect, useState} from "react";
import {FluxEvent, Permission} from "../Enums";
import store from "../store";
import Constant from "../Constant";
import Dispatcher from "../dispatcher";

const MenuItems = [
  {
    NAME: "Users",
    LINK: Constant.url.USERS,
    PERMISSION: [Permission.ADMIN]
  },
  {
    NAME: "Distributors",
    LINK: Constant.url.DISTRIBUTORS,
    PERMISSION: [Permission.DELIVERY]
  },
  {
    NAME: "Licences",
    LINK: Constant.url.LICENCES,
    PERMISSION: [Permission.SUPPORT,Permission.DELIVERY]
  },
  {
    NAME: "Features",
    LINK: Constant.url.FEATURES,
    PERMISSION: [Permission.DELIVERY]
  },
  {
    NAME: "Feature Groups",
    LINK: Constant.url.FEATURE_GROUPS,
    PERMISSION: [Permission.DELIVERY]
  },
]

function getPermittedMenuItems(permissions = store.session?.permissions) {
  return MenuItems.filter(elem => {
    for (let i = 0; i < elem.PERMISSION.length; i++) {
      if (permissions?.includes(elem.PERMISSION[i])) {
        return true;
      }
    }
    return false;
  })
}

export function MyMenuItems() {
  const [permissions, setPermissions] = useState(store.session?.permissions);

  useEffect(() => {
    const d = Dispatcher.register(payload => {
      if (payload.contentType === FluxEvent.PERMISSIONS_CHANGED) {
        setPermissions(store.session?.permissions);
      }
    });

    return () => {
      Dispatcher.unregister(d);
    };
  }, []);

  return getPermittedMenuItems(permissions).map(elem => <Nav.Link href={"#"+elem.LINK} key={elem.NAME}>{elem.NAME}</Nav.Link>)
}

export function getFirstMenuItem() {
  const items = getPermittedMenuItems();

  if (items.length) {
    return items[0].LINK;
  } else {
    return Constant.url.NO_PERMISSION
  }
}
